import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { WhiteTooltip } from '@AMIEWEB/Common';
import { missingField } from 'app/constants';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { isInValidAmount } from '../Utils';

const useCustomTooltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = useCustomTooltip();
  const getTitle = props => {
    return isInValidAmount(props.value) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(cellParams)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!cellParams?.row?.amount ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {isNullOrUndefined(cellParams?.row?.amount) ? missingField : `$${cellParams.row.amount}`}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorTooltipAmount = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
